import React from 'react';
import {
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement,
} from 'react-stripe-elements';
import TextField from '@material-ui/core/TextField';
import StripeInput from './StripeInput';
import FormTextField from 'Components/FormTextField';

function StripeTextField(props) {
  const { InputLabelProps, stripeElement, InputProps, ...other } = props;

  // return (
  //   <FormTextField
  //     fullWidth
  //     required
  //     InputLabelProps={{
  //       ...InputLabelProps,
  //       shrink: true,
  //     }}
  //     InputProps={{
  //       ...InputProps,
  //       inputProps: {
  //         component: stripeElement,
  //       },
  //       inputComponent: StripeInput,
  //     }}
  //     {...other}
  //   />
  // );

  return (
    <TextField
      fullWidth
      required
      InputLabelProps={{
        ...InputLabelProps,
        shrink: true,
      }}
      InputProps={{
        ...InputProps,
        style: {
          height: '50px',
          marginTop: '10px',
        },
        inputProps: {
          component: stripeElement,
          className: 'bg-transparent',
        },
        inputComponent: StripeInput,
      }}
      {...other}
    />
  );
}

export function StripeTextFieldNumber(props) {
  return (
    <StripeTextField
      label="Credit Card Number"
      stripeElement={CardNumberElement}
      {...props}
    />
  );
}

export function StripeTextFieldExpiry(props) {
  return (
    <StripeTextField
      label="Expires"
      stripeElement={CardExpiryElement}
      {...props}
    />
  );
}

export function StripeTextFieldCVC(props) {
  return (
    <StripeTextField
      label="CVC Code"
      stripeElement={CardCVCElement}
      {...props}
    />
  );
}
